import { API, getToken } from "./api";

const handlers = new Set();
let es = null, backoff = 1000, connected = false, timer = null;
const stateFns = new Set();

export const onEvent = (fn) => { handlers.add(fn); return () => handlers.delete(fn); };
export const onState = (fn) => { stateFns.add(fn); fn(connected); return () => stateFns.delete(fn); };
export const isLive = () => connected;
const setState = (v) => { if (connected !== v) { connected = v; stateFns.forEach((f) => f(v)); } };

const TYPES = ["ready", "notification", "report.submitted", "report.in_review", "report.approved", "report.rejected", "config.changed", "employee.changed", "asset.moved", "inventory.changed", "request.changed"];

export function connectRealtime() {
  disconnectRealtime();
  const token = getToken();
  if (!token || typeof EventSource === "undefined") return;
  es = new EventSource(`${API}/events?token=${encodeURIComponent(token)}`);
  TYPES.forEach((t) => es.addEventListener(t, (e) => {
    if (t === "ready") { setState(true); backoff = 1000; return; }
    let data = {}; try { data = JSON.parse(e.data); } catch {}
    handlers.forEach((fn) => fn({ type: t, ...data }));
  }));
  es.onerror = () => {
    setState(false); es?.close(); es = null;
    timer = setTimeout(connectRealtime, backoff);
    backoff = Math.min(backoff * 2, 30000);
  };
}
export function disconnectRealtime() {
  clearTimeout(timer); if (es) { es.close(); es = null; } setState(false);
}
